var _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Checklist50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M23 22H43V26H23zM23 9H43V13H23zM23 35H43V39H23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F51B5",
    d: "M15 16H5V6h10V16zM15 29H5V19h10V29zM15 42H5V32h10V42z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 35H12V39H8zM8 9H12V13H8zM8 22H12V26H8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M9 23H11V25H9zM9 10H11V12H9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Checklist50);
export default __webpack_public_path__ + "static/media/icons8-checklist-50.2ac92017ec8dea0bdd3a17ea24a28be6.svg";
export { ForwardRef as ReactComponent };